// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {
    getWipClaimIndicator,
    isMatchingStatus,
    mapWipClaimColorCoding,
    mapWipClaimStatus,
    wipClaimStatus
} from '../shared/services/home-page-helper';
import Accordion from '../../shared/components/accordion';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import WipClaim from '@deere/cps-it.warranty-model-factory/lib/wip-claims';
import WipClaimItem from './wip-item';

const WipClaims = props => {

    const claimTotal = Object.values(props.wipClaim).reduce((a, b) => a + b, 0) - props.wipClaim.laborRateChange;

    const accordionTitle = (
        <WipClaimItem
            className={getWipClaimIndicator(props.wipClaim, claimTotal)}
            count={claimTotal}
            status='CLAIMS'
        />
    );

    const accordionBody = (
        wipClaimStatus.filter(status => isMatchingStatus(status.key, props.claimStatuses))
            .map((status, index) =>
                <WipClaimItem
                    className={mapWipClaimColorCoding(status.key, props.wipClaim)}
                    count={mapWipClaimStatus(status.key, props.wipClaim)}
                    key={index}
                    status={status.value}
                    statusKey={status.key}
                />
            )
    );

    return (
        <Accordion
            accordionId='claim-indicators'
            body={accordionBody}
            title={accordionTitle}
        />
    );

};

WipClaims.displayName = 'WipClaims';
WipClaims.propTypes = {
    claimStatuses: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    wipClaim: PropTypes.instanceOf(WipClaim).isRequired
};

export default WipClaims;



// WEBPACK FOOTER //
// ./src/home-page/components/wip-claims.js